import { SID_COMMON_BASE_URL } from 'Modules/shareholders-id/constants';

export default {
  templateUrl: `${SID_COMMON_BASE_URL}/components/sid-request-results-image/sid-request-results-image.template.html`,
};
